import React from "react";

const CustomerRulesAndRegulations = (props) => {
  return (
    <section
      id="id_ico_about_section"
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled">
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h3 className="title_text text-dark">
                  Customer Account Milestone Policy
                </h3>

                <p className="info_description text-dark opacity-75 mb-3">
                  To ensure fairness, transparency, and the integrity of the
                  TopCoin UK system, all participants must adhere to the
                  following terms and conditions. These policies are established
                  to maintain an active, accountable, and equitable rewards
                  network for all users across the United Kingdom.
                </p>
                <strong>
                  <ol className="text-dark opacity-75 ">
                    <li className="mt-2 ">
                      Milestone Requirement
                      <p className="info_description text-dark opacity-75 mt-2">
                        Upon registration with TopCoin UK Ltd, each customer is
                        required to achieve the second milestone level of
                        twenty-two thousand (22,000) TopCoin within a period of
                        three (3) years from the date of account activation.
                      </p>
                      <p className="info_description text-dark opacity-75 mt-2">
                        This milestone requirement is part of the TopCoin UK
                        loyalty and rewards structure and does not represent an
                        investment target or financial obligation. It is
                        designed solely to support participation, engagement,
                        and continued eligibility within the TopCoin UK rewards
                        system.
                      </p>
                    </li>

                    <li className="mt-2">
                      Failure to Meet the Milestone
                      <p className="info_description text-dark opacity-75 mt-2">
                        If a customer does not reach the required milestone
                        within the specified timeframe, their account may be
                        closed in accordance with TopCoin UK policy. Any unused
                        or unclaimed TopCoins may be reassigned within the
                        system to support active and eligible customers.
                      </p>
                    </li>

                    <li className="mt-2">
                      Account Closure Policy
                      <p className="info_description text-dark opacity-75 mt-2">
                        Once an account has been closed under this policy, the
                        individual will not be able to create or register
                        another account using the same personal details, name,
                        or identification at any time in the future.
                      </p>
                    </li>

                    <li className="mt-2">
                      Limited Allocation of TopCoin (UK Only)
                      <p className="info_description text-dark opacity-75 mt-2">
                        There is a limited allocation of thirty million
                        (30,000,000) TopCoins dedicated to customers within the
                        United Kingdom, Scotland, and Wales. No additional
                        TopCoins will be issued beyond this allocation. If a
                        customer does not reach the milestone within the
                        timeframe, their account may be closed and any unclaimed
                        TopCoins may be reassigned to maintain fair distribution
                        and system balance.
                      </p>
                    </li>
                    
                  </ol>
                </strong>
                <strong>
                  <ol className="text-dark opacity-75" start="5">
                    <li className="mt-2">
                      Additional Topcoin allocations for other countries and
                      regions will be announced in future phases of
                      international expansion. The total number of Topcoins
                      available for each country will be formally disclosed by
                      Topcoin UK ltd at the time of release.
                    </li>
                    <li className="mt-2">Purpose of the Milestone Policy</li>
                  
                

                
                <p className="info_description text-dark opacity-75 mb-0">
                  The milestone requirement of 22,000 Topcoins has been
                  introduced to:
                  <strong>
                  <ul className="text-dark opacity-75">
                    <li className="mt-2">
                      Encourage consistent and active participation within the
                      Topcoin UK network.
                    </li>
                    <li className="mt-2">
                      Prevent account inactivity and accumulation of unused
                      Topcoins.
                    </li>
                    <li className="mt-2">
                      Ensure that available Topcoins are circulated among active
                      and genuine users.
                    </li>
                    <li className="mt-2">
                      Maintain system stability, fairness, and long-term
                      sustainability of the Topcoin UK economy.
                    </li>
                  </ul>
                </strong>
                </p>
                </ol>
                </strong>
                
                <br />
                <strong>
                  <ol className="text-dark opacity-75" start="7">
                    <li className="mt-2">
                      Topcoin UK ltd reserves the right to verify, audit, and
                      enforce compliance with this policy at its sole discretion
                      and to take any necessary action deemed appropriate in
                      accordance with company procedures and applicable UK laws.
                    </li>
                  </ol>
                </strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerRulesAndRegulations;
